import { render } from "./Interview.vue?vue&type=template&id=cd4223f4"
import script from "./Interview.vue?vue&type=script&lang=js"
export * from "./Interview.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\carl.DC_ADVOCATIA\\Documents\\GitHub\\benefit-screening-client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__